<div class="timer" *ngIf="countdownDate">
  <ul class="list-unstyled">
    <li><span id="days"> {{daysToDday}}</span>روز</li>
    <li><span id="hours"> {{hoursToDday}}</span>ساعت</li>
    <li><span id="minutes"> {{minutesToDday}}</span>دقیقه</li>
    <li><span id="seconds"> {{secondsToDday}}</span>ثانیه</li>
  </ul>
</div>
